import UserSessionDataHandler from '../../../auth/UserSessionsDataHandler';

export const getZonesFromUserSettings = () => {
  const userDashboardData = UserSessionDataHandler.getFromUserSettingsObjectInStore(
    UserSessionDataHandler.defaultDashboard
  );
  return userDashboardData?.zones ? userDashboardData.zones : [];
};
